var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_548",
    "data-name": "Grupo 548",
    transform: "translate(-0.277)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_151",
    "data-name": "Elipse 151",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "translate(0.277)",
    fill: "rgb(132, 170, 255)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-man",
    "data-name": "Icon ionic-ios-man",
    transform: "translate(26.503 11.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2279",
    "data-name": "Caminho 2279",
    d: "M19.8,11.1h-.022a4.99,4.99,0,1,1,5.012-4.99A5,5,0,0,1,19.8,11.1Z",
    transform: "translate(-7.275 -1.125)",
    fill: "#343131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2280",
    "data-name": "Caminho 2280",
    d: "M18.708,50.053c-1.586,0-2.974-1.157-2.974-3.349l.11-30.578h-1.1V27.693a2.672,2.672,0,0,1-.7,2.016,2.341,2.341,0,0,1-3.349,0,2.653,2.653,0,0,1-.7-2.016V14.3a6.362,6.362,0,0,1,1.52-4.23,5.625,5.625,0,0,1,4.3-1.983H29.272a5.6,5.6,0,0,1,4.3,1.994,6.334,6.334,0,0,1,1.52,4.219V27.693a2.611,2.611,0,0,1-.727,2.016,2.476,2.476,0,0,1-3.415,0,2.611,2.611,0,0,1-.727-2.016V16.127h-.991V46.7a3.085,3.085,0,0,1-3.062,3.349c-1.476,0-2.9-1.024-3.018-3.282V31.218H21.826v15.52A3.133,3.133,0,0,1,18.708,50.053Z",
    transform: "translate(-9.984 2.819)",
    fill: "#343131"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomem);
export default __webpack_public_path__ + "static/media/homem.4a4c55a2b1b281933864b9fe3fdacf05.svg";
export { ForwardRef as ReactComponent };